// Getippte Entwuerfe je Zeile eines Katalogs (Rollen- und Stichwortkatalog):
// Wer an einer Zeile zu tippen beginnt und dann eine andere Zeile oeffnet,
// findet beim Zurueckkehren seinen Text wieder. Es ist immer nur eine
// Rueckfrage offen; verloren geht dabei nichts, und es braucht keine zweite
// Frage "Aenderung verwerfen?" ueber der ersten.
//
// Vergessen wird ein Entwurf, wenn er erledigt ist (gespeichert) oder bewusst
// abgebrochen wurde. Er lebt nur im Speicher der Seite und gilt nur, solange
// die Zeile den Stand hat, auf dem er begonnen wurde: hat inzwischen jemand
// anderes umbenannt, zeigte ein alter Entwurf eine Aenderung an, die so
// niemand mehr meint -- dann steht wieder der heutige Wert im Feld.

import { useCallback, useMemo, useState } from 'react';

export interface ZeilenEntwuerfe {
  /** Der Entwurf der Zeile, wenn er auf `heute` begonnen wurde; sonst `heute`. */
  readonly lesen: (zeile: string, heute: string) => string;
  /** `basis` ist der Wert der Zeile, auf dem der Entwurf beginnt. */
  readonly merken: (zeile: string, wert: string, basis: string) => void;
  readonly vergessen: (zeile: string) => void;
}

export function useZeilenEntwuerfe(): ZeilenEntwuerfe {
  const [entwuerfe, setEntwuerfe] = useState<ReadonlyMap<string, { readonly wert: string; readonly basis: string }>>(new Map());
  const lesen = useCallback(
    (zeile: string, heute: string): string => {
      const entwurf = entwuerfe.get(zeile);
      return entwurf !== undefined && entwurf.basis === heute ? entwurf.wert : heute;
    },
    [entwuerfe],
  );
  const merken = useCallback(
    (zeile: string, wert: string, basis: string): void => setEntwuerfe((alt) => new Map(alt).set(zeile, { wert, basis })),
    [],
  );
  const vergessen = useCallback(
    (zeile: string): void =>
      setEntwuerfe((alt) => {
        if (!alt.has(zeile)) return alt;
        const neu = new Map(alt);
        neu.delete(zeile);
        return neu;
      }),
    [],
  );
  return useMemo(() => ({ lesen, merken, vergessen }), [lesen, merken, vergessen]);
}
